import { useContext, useEffect, useMemo } from "react";
import dayjs from "dayjs";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DataContext } from "src/contexts/DataContext";
import "./dropdown.css";
import ZoomTo from "../zoomto/zoomto";

export function CustomDropdown() {
  const { key, setKey, availableKeys } = useContext(DataContext);

  function handleChange(e) {
    setKey(e.target.value);
  }

  return (
    <FormControl id="set-key-dropdown">
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={key}
        label="data-key"
        onChange={handleChange}
      >
        {availableKeys.map((k) => (
          <MenuItem value={k} key={k}>
            {k}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export function Panel() {
  const {
    window: timeWindow,
    dataWindow,
    setDataWindow,
  } = useContext(DataContext);

  const timeSelectionSmallEnough = useMemo(
    () => dayjs(timeWindow?.[1]).diff(dayjs(timeWindow?.[0]), "hours") < 12,
    [timeWindow]
  );

  return (
    <div className="panel top-left">
      <CustomDropdown />
      <ZoomTo />
      {timeSelectionSmallEnough && dataWindow.length !== 2 ? (
        <button className="add-data" onClick={() => setDataWindow(timeWindow)}>
          Add Detail
        </button>
      ) : dataWindow.length === 2 ? (
        <button className="add-data" onClick={() => setDataWindow([])}>
          Remove Detail
        </button>
      ) : null}
    </div>
  );
}
